<template>
  <div :class="jel_getClassObject(content)">
    <component
      :is="'MediaImage' + content.format.replace('mediaImage', '')"
      :key="content.image['@id']"
      :content="content"
    >
    </component>
  </div>
</template>

<script>
import MediaImageApercu from './MediaImageApercu'; // Image 90% et texte
import MediaImageExplorer from './MediaImageExplorer'; // Image de base / lien
import MediaImageSimple from './MediaImageSimple'; // Image de base avec aucun texte
import MediaImageImg90TitSouTit from './MediaImageImg90TitSouTit'; // Image à 90% et Titre/Sous titre au dessous
// Réutilisation composant Bingo pour page Accueil Portail
import MediaImageImg70tit30 from '../../bingo/media/image/MediaImageImg70tit30.vue';

export default {
  name: 'MediaImage',
  components: {
    MediaImageApercu,
    MediaImageExplorer,
    MediaImageImg70tit30,
    MediaImageImg90TitSouTit,
    MediaImageSimple,
  },
  props: { content: { type: Object, required: true } },
};
</script>
